"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Dropdown = _interopRequireDefault(require("../Dropdown/Dropdown"));

var _ButtongroupFilters = _interopRequireDefault(require("./ButtongroupFilters"));

var _ButtonFilter = _interopRequireDefault(require("./ButtonFilter"));

require("./NavFilter.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class NavFilter extends _react.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      filters: [],
      expanded: false,
      selected: undefined
    });

    _defineProperty(this, "componentDidUpdate", (prevProps, prevState) => {
      if (prevProps.filters !== this.props.filters) {
        this.getFilters();
      }
    });

    _defineProperty(this, "getClassName", () => {
      const _this$props = this.props,
            className = _this$props.className,
            align = _this$props.align;
      let classNames = [];
      classNames.push(className);
      classNames.push(className + '--' + align);
      return classNames.join(' ');
    });

    _defineProperty(this, "getFilters", () => {
      const filters = this.props.filters;
      let selected = filters.find(filter => filter.selected === true);

      if (!selected) {
        selected = filters[0];
      }

      this.setState({
        filters: filters,
        selected: selected
      });
    });

    _defineProperty(this, "onSelect", (filter, event) => {
      if (this.props.onSelect) {
        this.props.onSelect(filter, event);
      }

      this.setState({
        selected: filter,
        expanded: false
      });
    });

    _defineProperty(this, "onToggle", () => {
      this.setState({
        expanded: !this.state.expanded
      });
    });

    _defineProperty(this, "renderFilter", (filter, index) => {
      const selected = this.state.selected;
      const title = filter.title;

      if (filter === selected) {
        return _react.default.createElement(_ButtonFilter.default, _extends({
          key: index
        }, filter, {
          icon: "check",
          selected: true
        }));
      }

      return _react.default.createElement(_ButtonFilter.default, _extends({
        key: index
      }, filter, {
        selected: false,
        onClick: event => this.onSelect(filter, event)
      }));
    });

    _defineProperty(this, "renderDropdown", () => {
      const _this$props2 = this.props,
            align = _this$props2.align,
            valign = _this$props2.valign;
      const _this$state = this.state,
            filters = _this$state.filters,
            expanded = _this$state.expanded;

      if (expanded) {
        return _react.default.createElement(_Dropdown.default, {
          align: align,
          valign: valign
        }, _react.default.createElement(_ButtongroupFilters.default, null, filters.map(this.renderFilter)));
      }
    });
  }

  componentDidMount() {
    this.getFilters();
  }

  render() {
    const _this$state2 = this.state,
          expanded = _this$state2.expanded,
          selected = _this$state2.selected;
    const buttonType = this.props.buttonType;
    const className = this.getClassName();
    return _react.default.createElement("nav", {
      className: className
    }, _react.default.createElement(_ButtonFilter.default, _extends({}, selected, {
      url: undefined,
      selected: false,
      haspopup: true,
      expanded: expanded,
      buttonType: buttonType,
      onClick: this.onToggle
    })), this.renderDropdown());
  }

}

_defineProperty(NavFilter, "defaultProps", {
  className: "nav-filter",
  buttonType: "filter",
  align: "left",
  valign: "top",
  filters: []
});

var _default = NavFilter;
exports.default = _default;
module.exports = exports.default;